import Vue from 'vue'
import { countingConfigFrom, createCountingModule } from '@ahaslides-product/frontend-toolkit'
import { getKvSyncApi } from '@/api/kvSync'
import kvSyncSubscriber from '@/mqtt/kvSync'
import config from '@/config'

export const countingConfig = () => countingConfigFrom(config)

export default createCountingModule({
  Vue,
  config,
  getKvSyncApi,
  kvSyncMqttSubscriber: kvSyncSubscriber,
  seedGroups: true,
})
